import { liveQuoteFormApiConnector } from 'apiConnector/secondary-market/live/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { liveInputFormActions } from 'state/secondaryMarket/live/form/input/inputForm.actions';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';
import { extractHttpErrorMessage } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function fetchLiveSettlementDateEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { getSettlementDate } = liveQuoteFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_SETTLEMENT_DATE_REQUESTED'),
      mergeMap(({ tabId, bcsProductKey, counterpartyEliotId, clientType }) => {
        return getSettlementDate(bcsProductKey, counterpartyEliotId, clientType).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(data => liveInputFormActions.settlementDateReceived(tabId, data.settlementDate)),
          catchError((err: HttpError) => {
            return of(
              liveInputFormActions.settlementDateRequestFailed(
                tabId,
                bcsProductKey,
                extractHttpErrorMessage(err, { backend: 'domino' })!,
              ),
            );
          }),
        );
      }),
    );
  };
}
